interface TParams { name: string, values: (string | number)[] }

interface OptionsProps {
    onChange?(params: TParams): void;
    onInit?(params: TParams): void;
}

class Checkboxes {
    private readonly checkboxesEl: HTMLInputElement[];
    private readonly options: OptionsProps | undefined;

    constructor(parent: HTMLElement, options?: OptionsProps) {
        if (!parent) {
            console.warn(`Parent is ${parent}`);
        }

        this.options = options;
        this.checkboxesEl = [].slice.call(parent.querySelectorAll('.checkboxes__checkbox'));

        if (options?.onInit) {
            options.onInit(this.getCheckedValues());
        }

        if (typeof options?.onChange === 'function' && this.checkboxesEl.length > 0) {
            parent.addEventListener('input', () => {
                if (options.onChange) {
                    options.onChange(this.getCheckedValues());
                }
            });
        }
    }

    reset(): void {
        if (!this.checkboxesEl.length) {
            return;
        }

        this.checkboxesEl.forEach((node) => {
            if (node.checked) {
                node.checked = false;
            }
        });

        if (this.options?.onChange) {
            this.options.onChange(this.getCheckedValues());
        }
    }

    private getCheckedValues = (): TParams => {
        return this.checkboxesEl.reduce((acc: any, el) => {
            if (el.checked) {
                acc.values.push(el.value);

                return acc;
            }

            return acc;
        }, {
            name  : this.checkboxesEl[0]?.name,
            values: []});
    };
}

export default Checkboxes;
